import { IconProps } from "../../../types/style";

const CreditChecked = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 12 13"
        fill="none"
      >
        <path
          d="M1 5.5H11"
          stroke={color}
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.77414 10.7499H3.21915C1.44415 10.7499 0.994141 10.3099 0.994141 8.55489V4.44489C0.994141 2.85489 1.36416 2.34488 2.75916 2.26488C2.89916 2.25988 3.05415 2.25488 3.21915 2.25488H8.77414C10.5491 2.25488 10.9991 2.69488 10.9991 4.44988V6.65488"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M3 8.5H5"
          stroke={color}
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11 9.5C11 9.875 10.895 10.23 10.71 10.53C10.365 11.11 9.73 11.5 9 11.5C8.27 11.5 7.63501 11.11 7.29001 10.53C7.10501 10.23 7 9.875 7 9.5C7 8.395 7.895 7.5 9 7.5C10.105 7.5 11 8.395 11 9.5Z"
          stroke={color}
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.2207 9.49976L8.7157 9.99477L9.7807 9.00977"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
};

export default CreditChecked;
